import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { LoginComponent } from './journey/login/login.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { SessionComponent } from './journey/session/session.component';
import { ThankyouComponent } from './journey/thankyou/thankyou.component';
import { VerifyPaymentComponent } from './journey/verify-payment/verify-payment.component';
import { LandingComponent } from './journey/landing/landing.component';
import { AgentComponent } from './agent/agent.component';
import { AccessibilityStatementComponent } from './journey/accessibility-statement/accessibility-statement.component';

const routes: Routes = [
	{
		path: 'start/order_a_copy_certificate',
		loadChildren: () =>
			import(
				'./certificate-ordering/certificates-order-journey-loader.module'
			).then((m) => m.CertificatesOrderJourneyLoaderModule),
	},
	{
		path: 'forms/corrections',
		loadChildren: () =>
			import('./applications/core/corrections.module').then(
				(m) => m.CorrectionsModule
			),
	},
	{
		path: 'forms/re-register_a_birth',
		loadChildren: () =>
			import('./applications/core/re-register-a-birth.module').then(
				(m) => m.ReRegisterABirthModule
			),
	},
	{ path: '', redirectTo: '/start', pathMatch: 'full' },
	{ path: 'departments', component: DepartmentsComponent },
	{ path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
	{
		path: 'start/:journey',
		component: LandingComponent,
	},
	{
		path: 'start',
		component: LandingComponent,
	},
	{
		path: 'services',
		component: ServicesComponent,
		data: { breadcrumb: 'Services' },
	},
	{
		path: 'services/:journey',
		component: ServicesComponent,
		data: { breadcrumb: 'Services' },
	},
	{ path: 'locations', component: LocationComponent },
	{
		path: 'calendar',
		component: CalendarComponent,
		data: { breadcrumb: 'Date & Time' },
	},
	{
		path: 'booking-details',
		component: BookingDetailsComponent,
		data: { breadcrumb: 'Booking Form' },
	},
	{
		path: 'summary',
		component: SummaryComponent,
		data: { breadcrumb: 'Summary' },
	},
	{
		path: 'confirmation',
		component: ConfirmationComponent,
		data: { breadcrumb: 'Confirmation' },
	},
	{
		path: 'payment-verify/:company/:basket/:serviceItems',
		component: VerifyPaymentComponent,
	},
	{ path: 'sessionExpired', component: SessionComponent },
	{ path: 'thankyou', component: ThankyouComponent },
	{ path: 'agent', component: AgentComponent },
	{
		path: 'accessibility-statement',
		component: AccessibilityStatementComponent,
		data: { breadcrumb: 'Accessibility Statement' },
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
